import { render, staticRenderFns } from "./QuestionarioSaude.vue?vue&type=template&id=cd1d802c&"
import script from "./QuestionarioSaude.vue?vue&type=script&lang=js&"
export * from "./QuestionarioSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports